<template>
    <section id="after-movies">
        <div class="secondary-heading text-center">ESSENS TURKEY 2024</div>
        <h1 class="text-center mb-5"> {{ $t('turkeyVideo') }} </h1>
        <div id="after-movies-container" class="container px-5 position-relative">
             <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://player.vimeo.com/video/974099151" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div> 
        </div>
    </section>
</template>

<style>
    #after-movies {
        background-color: var(--grey-bg);
    }
</style>